<template>
  <div class="table-item item--status" :class="main ? 'group-start' : ''">
    <div class="item">
      <p class="item__value" v-if="item.hasActionInProgress()">
        <v-icon class="text--gray-lighten1" :size="20">$loader</v-icon>
      </p>
      <status-indicator v-else :sameSize="true" :instance="item" />
    </div>
  </div>
</template>

<script>
import StatusIndicator from "../StatusIndicator.vue";

export default {
  components: {
    StatusIndicator,
  },
  props: {
    item: {
      type: Object,
    },
    main: {
      type: Boolean,
      default: false,
    },
  },
};
</script>